const { trackGtm } = require('../../../../js/functions');

module.exports = {
	init() {
		const smallImagesAboveTitleList = this.root.querySelectorAll(
			'.small-image-above-title a',
		);

		const closeError = this.root.querySelector('.videos-highlight--close');

		if (closeError)
			closeError.addEventListener('click', this.hideWarning.bind(this));

		smallImagesAboveTitleList.forEach(element => {
			element.addEventListener('click', () => {
				trackGtm({
					eventCategory: 'cta',
					eventAction: 'video',
					eventLabel: element.href,
				});
			});
		});
	},
	hideWarning() {
		const modalError = this.root.querySelector('.videos-highlight--warning');
		modalError.style.display = 'none';
	},
};
